import { ResumeDto } from "@reactive-resume/dto";
import { useQuery } from "@tanstack/react-query";

import { RESUME_KEY } from "@/client/constants/query-keys";
import { axios } from "@/client/libs/axios";
import { useResumeStore } from "@/client/stores/resume";
import { jwtDecode } from "jwt-decode";

let userInfo: any;

let client_id: any; //= window.location.pathname.slice(1);
let token: any;

const b64toBlob = (base64Image: string) => {
  // Split into two parts
  const parts = base64Image.split(";base64,");

  // Hold the content type
  const imageType = parts[0].split(":")[1];

  // Decode Base64 string
  const decodedData = window.atob(parts[1]);

  // Create UNIT8ARRAY of size same as row data length
  const uInt8Array = new Uint8Array(decodedData.length);

  // Insert all character code into uInt8Array
  for (let i = 0; i < decodedData.length; ++i) {
    uInt8Array[i] = decodedData.charCodeAt(i);
  }

  // Return BLOB image after conversion
  return new Blob([uInt8Array], { type: imageType });
};
function removeNullsAndReplaceWithEmpty(obj: any) {
  for (var key in obj) {
    if (obj[key] === null) {
      obj[key] = "";
    } else if (typeof obj[key] === "object") {
      // Recursively call the function for nested objects
      obj[key] = removeNullsAndReplaceWithEmpty(obj[key]);
    }
  }
  return obj;
}

function getCookies() {
  return document.cookie.split("; ").reduce((acc: any, cookie) => {
    const [key, value] = cookie.split("=");
    acc[key] = decodeURIComponent(value);
    return acc;
  }, {});
}

export const findResumeById = async (data: { id: string; userId: string }) => {
  async function setUserProfile() {
    try {
      const cookies = getCookies();

      let user_token_cookie = cookies["token"];

      const payload: any = jwtDecode(user_token_cookie);
      if (payload == null || !payload.app) {
        return { user_token: 123, user_dlid: null, user_id: null, client_id: null };
      }

      const hostName = window.location.origin;

      const resp: any = await axios.post(
        `/resume/validateToken`,
        { app: payload.app },
        {
          headers: {
            Authorization: `Bearer ${user_token_cookie}`,
          },
        },
      );

      if (resp.data.status_code != 200) {
        window.location.href = hostName + "/pagenotfound";
      }

      let id = payload.sub;
      let client_id_1 = payload.app;
      let token = await generateToken(id, client_id_1);

      sessionStorage.setItem("token", token);
      client_id = client_id_1;

      return { user_token: token, user_dlid: null, user_id: id, client_id: client_id };
      // }
      return { user_token: null, user_dlid: null, user_id: null };
    } catch (error: any) {
      console.error("Error:", error.response?.data || error.message);
      return { user_token: 123, user_dlid: null, user_id: null, client_id: null };
    }
  }

  async function generateToken(id: number, client_id: string) {
    // Generate a random salt
    const salt = Math.floor(Math.random() * (9999999999 - 1111111111 + 1)) + 1111111111;
    const secure = Math.floor(Math.random() * (9999 - 1111 + 1)) + 1111;

    // Extract user details
    const userid = id;
    const clientid = client_id;

    // Create the token string
    const tokenString = `${salt}${clientid}unnnd${userid}${secure}`;

    // Encode the token string to Base64 using btoa
    const base64Token = btoa(tokenString); // Encoding to base64

    return base64Token;
  }

  if (!client_id) {
    let userinfo = await setUserProfile(); // {user_token:token, user_dlid:dlid, user_id:id }
    client_id = userinfo.client_id;

    token = userinfo.user_token;
  } else {
    client_id = sessionStorage.getItem("token");
  }
  const hostName = window.location.origin;

  const response = await axios.get(`/resume/one/${token}`);
  if (response.data.status_code && response.data.status_code == 404) {
    window.location.href = hostName + "/pagenotfound";
  }

  var regexBase64 = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
  if (
    response.data.data.basics.picture.url != "" &&
    regexBase64.test(response.data.data.basics.picture.url)
  ) {
    let blob_url: any = b64toBlob(response.data.data.basics.picture.url);

    blob_url = window.URL.createObjectURL(blob_url);

    response.data.data.basics.picture.url = blob_url;
    document.getElementsByClassName("dropbtn")[0].getElementsByTagName("img")[0].src = blob_url;
  } else {
    document.getElementsByClassName("dropbtn")[0].getElementsByTagName("img")[0].src =
      response.data.data.basics.picture.url;
  }

  response.data = removeNullsAndReplaceWithEmpty(response.data);
  return response.data;
};

export const findResumeByUsernameSlug = async (data: { username: string; slug: string }) => {
  const response = await axios.get<ResumeDto>(`/resume/public/${data.username}/${data.slug}`);

  return response.data;
};

export const useResume = (id: string, userId: string) => {
  const {
    error,
    isPending: loading,
    data: resume,
  } = useQuery({
    queryKey: [RESUME_KEY, { id }, { userId: client_id }],
    queryFn: () => findResumeById({ id, userId }),
  });

  useResumeStore.setState({ resume });
  useResumeStore.temporal.getState().clear();

  return { resume, loading, error };
};
